import CryptoJS from 'crypto-js';
import { useEffect, useState } from 'react';
import styles from './PostRegistration.module.css';
import { loaduser, assignOverwolfDataToUser } from "../actions/userAction";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";

import Overwolf_App_Download from '../images/newdownloadbutton.svg';
import OverwolfLogo from '../images/Overwolf_logo.png';
import Arrow from '../component/Arrow.js';

export const PostRegistration = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [userdata] = useState(
        JSON.parse(localStorage.getItem("nftuser"))
    );

    useEffect(() => {
        console.log("User: ", JSON.parse(localStorage.getItem("nftuser")));
    }, []);

    useEffect(() => {
        const overwolfDataCheck = async (event) => {
            if (event.origin !== process.env.REACT_APP_BASE_URL || event.data?.type !== "overwolfToken") return;
            if (!event.data?.overwolfToken?.access_token) return;

            await dispatch(assignOverwolfDataToUser(event.data?.overwolfToken?.access_token, userdata._id));
            if(userdata?.available_fund <= 0 && userdata?.bonus_fund <= 0) {
                navigate("/registration-deposit");
            } else {
                navigate("/SoloShowdown");
            }
        };

        window.addEventListener("message", overwolfDataCheck);

        return () => {
            window.removeEventListener("message", overwolfDataCheck);
        };
    },[]);

    const handleOverwolf = (e) => {
        e.preventDefault();
        const overwolfAuthBaseUrl = 'https://id.overwolf.com/oidc/auth';
    
        function generateCodeVerifier() {
          const randomArray = new Uint8Array(32);
          window.crypto.getRandomValues(randomArray);
          return btoa(String.fromCharCode(...randomArray))
            .replace(/=/g, '')
            .replace(/\+/g, '-')
            .replace(/\//g, '_');
        }
        function generateCodeChallenge(codeVerifier) {
          const hash = CryptoJS.SHA256(codeVerifier);
          const base64String = hash.toString(CryptoJS.enc.Base64);
          return base64String
            .replace(/=/g, '')
            .replace(/\+/g, '-')
            .replace(/\//g, '_');
        }
    
        const codeVerifier = generateCodeVerifier();
        localStorage.setItem("overwolfVerifier", codeVerifier);
        const codeChallenge = generateCodeChallenge(codeVerifier);
    
        const authParams =(
          "?client_id=" + process.env.REACT_APP_OVERWOLF_CLIENT_ID +
          "&redirect_uri=" + process.env.REACT_APP_OVERWOLF_REDIRECT_URI +
          "&scope=openid+profile+email" +
          "&code_challenge=" + codeChallenge +
          "&code_challenge_method=S256" +
          "&response_type=code"
        );
    
        const overwolfFullAuthUrl = overwolfAuthBaseUrl + authParams;
    
        window.open(
          overwolfFullAuthUrl,
          "_blank"
        );
        dispatch(loaduser());
      };

    return (
        <div className={styles.mainContainer}>
            <div className={styles.contentContainer}>
                <h1 style={{ color: "#FFFFFF", textAlign: "center", marginTop: "35px", marginBottom: "50px", fontSize: "28px" }}>
                    Your Gamewagrs Account Is Almost Ready!
                </h1>
                <p style={{ color: "#8692A6", textAlign: "center", marginBottom: "30px" }}>
                    You must now link your Overwolf account so<br />Gamewagrs can track your progression in challenges
                </p>
                <button
                    className={styles.overwolfButton}
                    onClick={handleOverwolf}
                >
                    <img src={OverwolfLogo} alt="Overwolf Logo" style={{ width: "45px" }} />
                    <span>Link your Overwolf Account</span>
                </button>
                <div className={styles.divider} />
                <h1 style={{ color: "#FFFFFF", textAlign: "center", marginBottom: "0px", fontSize: "24px" }}>
                    Download the Validator App!
                </h1>
                <p style={{ color: "#8692A6", textAlign: "center", marginBottom: "40px", fontSize: "14px", fontStyle: "italic" }}>
                    The Validator App is what tracks your stats and results for<br />challenge validation. It takes {"<"}2 minutes to install.
                </p>
                <div style={{ marginBottom: "40px" }}>
                    <a href="https://www.overwolf.com/app/Gamewagrs.com-GameWagrs" target="_blank">
                        <img loading="lazy" alt="logo" className="image" width={"180px"} src={Overwolf_App_Download} />
                    </a>
                </div>
                <span style={{ 
                    whiteSpace: "nowrap", 
                    color: "#8692A6", 
                    fontWeight: "500", 
                    textAlign: "center", 
                    marginTop: "20px", 
                    fontSize: "16px" 
                }}>
                    <span style={{ color: "#66FF66" }}>Account Created</span>
                    <span style={{ margin: "0 15px" }}>
                        <Arrow color='#757575' width={3} size={24} />
                    </span> 
                    Link Overwolf
                    <span style={{ margin: "0 15px" }}>
                        <Arrow color='#757575' width={3} size={24} />
                    </span> 
                    Download Validator
                    <span style={{ margin: "0 15px" }}>
                        <Arrow color='#757575' width={3} size={24} />
                    </span> 
                    Deposit Funds
                </span>
            </div>
        </div>
    );
}